import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
// import { styled } from '@mui/material/styles';
import { withStyles } from '@mui/styles';

import { Link } from 'react-router-dom';
// import {history } from '../routers/Router';
import uniqid from 'uniqid';
import '../css/DeleteChannel.css';
// import createHistory from 'history/createBrowserHistory';


//delete channel component of ai channel section page


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 4,
    width: '60vw',
  },
});


class DeleteChannel extends React.Component{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: false,
    channelName: '',
    channelNumber: '',
    ChannelArray: '',
    ChannelGenre: '',
    ChannelLogoUrl: '',
    editButtonDisable: true,
    editByChannelName: true,
  };
  this.closeModal = this.closeModal.bind(this);
}

closeModal() {
  this.setState({
    modalIsOpen: false
  });
  window.location.href ='/ai/addchannel';
}

componentWillMount(){
  let locationParameter = window.location.search;
  let searchingType =  locationParameter.substring(1,2);
  let searchOption  =  locationParameter.slice(2);
  searchOption = decodeURIComponent(searchOption);

  if(searchingType==='0'){
    this.setState({
      editByChannelName: false,
      channelNumber: searchOption
    })
  }else{
    this.setState({
      channelName: searchOption,
      editByChannelName: true
    })
  }
}


//data from sandeep
// componentDidMount(){
//   var headers = {
//     "Content-Type": "application/json",
//     "Access-Control-Allow-Origin": "*",
//     "Cookie": "csrftoken=zZGTDHZ6VMmkuMOR6iYbnat1CKBpgpVbAGWUOnaLWQVAhykJvW5B8TM09TMNhC8H",
//     "X-CSRFToken": "zZGTDHZ6VMmkuMOR6iYbnat1CKBpgpVbAGWUOnaLWQVAhykJvW5B8TM09TMNhC8H"
//   }
//   var bodyForChange;
//   var cardstest = this.state.channelName;
//   var cardschannelnumbertest = this.state.channelNumber;
//   if(this.state.editByChannelName){
//     bodyForChange = JSON.stringify({
//       cardstest,
//       csrfmiddlewaretoken: 'KQOJMxg5j3VQHN8GaHQzArNMVwXBNtb0Lx4KXdrKk7u6uzEyzlXZla6LsF8ZOGow',
//     })
//   }else{
//     bodyForChange = JSON.stringify({
//       cardschannelnumbertest,
//       csrfmiddlewaretoken: 'KQOJMxg5j3VQHN8GaHQzArNMVwXBNtb0Lx4KXdrKk7u6uzEyzlXZla6LsF8ZOGow',
//     })
//   }

//   fetch('/d2heditdata/' ,{
//     method: "POST",
//     headers: headers,
//     body: bodyForChange
// })
//          .then(response => {
              // if(response.status===403){
              //   localStorage.removeItem('token');
              //   localStorage.removeItem('csrftoken');
              //   localStorage.removeItem('auth');
              //   const history = createHistory({forceRefresh: true})
              //   window.location.href =('/session-timeout')
              // }else{
              //     return response.json()}
              // })
// .then(data => this.fetchChannelDetails(data))
// .catch(error => console.error(error))
// }

componentDidMount(){
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  var bodyForChange;
  var cardstest = this.state.channelName;
  var cardschannelnumbertest = this.state.channelNumber;
  if(this.state.editByChannelName){
    bodyForChange = JSON.stringify({
      cardstest,
    })
  }else{
    bodyForChange = JSON.stringify({
      cardschannelnumbertest,
    })
  }

  fetch('/cloud/d2heditdata/' ,{
    method: "POST",
    headers: headers,
    body: bodyForChange
})
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
.then(data => {
  console.log(data)  
  this.fetchChannelDetails(data)
})
.catch((err)=>{
  console.log(err)
})
}

//data getting from sandeep
// onDeleteClick = (e) => {
//   var headers = {
//     "Content-Type": "application/json",
//     "Access-Control-Allow-Origin": "*",
//     "Cookie": "csrftoken=zZGTDHZ6VMmkuMOR6iYbnat1CKBpgpVbAGWUOnaLWQVAhykJvW5B8TM09TMNhC8H",
//     "X-CSRFToken": "zZGTDHZ6VMmkuMOR6iYbnat1CKBpgpVbAGWUOnaLWQVAhykJvW5B8TM09TMNhC8H"
//   }
//   var bodyForChange = JSON.stringify({
//     csrfmiddlewaretoken: 'KQOJMxg5j3VQHN8GaHQzArNMVwXBNtb0Lx4KXdrKk7u6uzEyzlXZla6LsF8ZOGow',
//     edit_channel_name: this.state.channelName,
//     edit_channel_number_value: this.state.channelNumber,
//     edit_channel_array: this.state.ChannelArray,
//     edit_logo: this.state.ChannelLogoUrl,
//     edit_genre: this.state.ChannelGenre,
//   })
//   fetch('/d2hfinalupdatedata/' ,{
//     method: "POST",
//     headers: headers,
//     body: bodyForChange
// })
// .then(response => {
//   if(response.status==200){
//     this.setState({
//       modalIsOpen: true
//     })
//   }
// })
//          .then(response => {
              // if(response.status===403){
              //   localStorage.removeItem('token');
              //   localStorage.removeItem('csrftoken');
              //   localStorage.removeItem('auth');
              //   const history = createHistory({forceRefresh: true})
              //   window.location.href =('/session-timeout')
              // }else{
              //     return response.json()}
              // })
// .then(data => {console.log(data)})
// .catch(error => console.error(error))
// }

onDeleteClick = (e) => {
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  var bodyForChange = JSON.stringify({
    delete_channel_name: this.state.channelName,
    delete_channel_number_value: this.state.channelNumber,
    delete_channel_array: this.state.ChannelArray,
    delete_logo: this.state.ChannelLogoUrl,
    delete_genre: this.state.ChannelGenre,
  })
  fetch('/cloud/d2hdeletechannel/' ,{
    method: "POST",
    headers: headers,
    body: bodyForChange
})
.then(response => {
  if(response.status==200){
    this.setState({
      modalIsOpen: true
    })
  }
})
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
.then(data => {console.log(data)})
.catch((err)=>{
  console.log(err)

})
}

onReset = () => {
  if(this.state.editByChannelName){
    this.setState({
      channelNumber: '',
      ChannelArray: '',
      ChannelGenre: '',
      ChannelLogoUrl: '',
      editButtonDisable: true,
    })
  }else{
    this.setState({
      channelName: '',
      ChannelArray: '',
      ChannelGenre: '',
      ChannelLogoUrl: '',
      editButtonDisable: true,
    })

  }

}

enableEditButton = () => {
  if(this.state.channelName==='' &&
     this.state.channelNumber==='' &&
     this.state.ChannelArray==='' &&
     this.state.ChannelGenre==='' &&
     this.state.ChannelLogoUrl===''    
  ){
    this.setState({
      editButtonDisable: true
    })
  }else{
    this.setState({
      editButtonDisable: false
    })
  }
}


imgUrlToBase64 =(url) =>{
  console.log(url)
  url= `/media/${url}`;
  this.toDataURL(url, (dataUrl) => {
    console.log(dataUrl);
    this.setState({
      ChannelLogoUrl: dataUrl,
    },()=>console.log(this.state))
   })  
}
toDataURL =(url, callback) => {
  var httpRequest = new XMLHttpRequest();
  httpRequest.onload = function() {
     var fileReader = new FileReader();
        fileReader.onloadend = function() {
           callback(fileReader.result);
        }
        fileReader.readAsDataURL(httpRequest.response);
  };
  httpRequest.open('GET', url);
  httpRequest.responseType = 'blob';
  httpRequest.send();
}


fetchChannelDetails = (data) => {
  this.imgUrlToBase64(data[0].logo);
  this.setState({
    channelName: data[0].channel_name,
    channelNumber: data[0].channel_Number,
    ChannelArray: data[0].channel_Array,
    ChannelGenre: data[0].genre,
    // ChannelLogoUrl: data[0].logo
  })
}
    render(){
        const { classes } = this.props;
        return (
            <div className="EditChannel">
              <div className="row editchannel-heading leading ">
                Details for Channel to be deleted
              </div>
              <div className="row">
              <div className="col-6">
                            <div className="row row-edit">
              <div className="group">
                 <input type="text" name="channelName" ref="channelName" className="row-edit"
                   value={this.state.channelName}              
                   required/>
                 <span className="highlight"></span>
                 <span className="bar"></span>
                 <label>Channel Name</label>
              </div>
              </div>
              <div className="row row-edit">
                <div className="group">
                   <input type="number" name="channelNumber" ref="channelNumber" className="row-edit"
                     value={this.state.channelNumber}
                     required/>
                   <span className="highlight"></span>
                   <span className="bar"></span>
                   <label>Channel Number</label>
                </div>
              </div>
              <div className="row row-edit">
                <div className="group">
                   <input type="text" name="ChannelArray" ref="ChannelArray" className="row-edit"
                     value={this.state.ChannelArray}
                     required/>
                   <span className="highlight"></span>
                   <span className="bar"></span>
                   <label>Channel Array if you want to edit</label>
                </div>
              </div>
              <div className="row row-edit">
                <div className="group">
                   <input type="text" name="ChannelGenre" ref="ChannelGenre" className="row-edit"
                     value={this.state.ChannelGenre}
                     />
                   <span className="highlight"></span>
                   <span className="bar"></span>
                   <label>Channel Genre</label>
                </div>
              </div>
              <div className="row row-edit">
                <div className="group">
                   <input type="text" name="ChannelLogoUrl" ref="ChannelLogoUrl" className="row-edit"
                     value={this.state.ChannelLogoUrl}
                     required/>
                   <span className="highlight"></span>
                   <span className="bar"></span>
                   <label>Channel Logo Url</label>
                </div>
                </div>
              </div>
              <div className="col-4 image-position m-3">
              <img src={this.state.ChannelLogoUrl}  id={uniqid()}/>  
              </div> 
              </div>

              <div className="swubmitbutton">
              <Link to='/ai/addchannel' >
                <div className="btn reset-btn mx-2 px-5">Cancel </div>
              </Link>
                <button className="btn edit-btn px-5 button-disabled" onClick={this.onDeleteClick.bind(this)} >Confirm Delete</button>
              </div>
              <Modal
                 isOpen={this.state.modalIsOpen}
                 onRequestClose={this.closeModal}
                 style={customStyles}
                  contentLabel="Example Modal">
              <div className="modal-add-device">
                <div className="float-right cross-times" onClick={this.closeModal}>
                  <i className="fas   fa-2x mr-2"></i>
                </div>
              </div>
            <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Channel Deleted Successfully</h3>
                <i class="fas fa-check-circle update"></i>
                <br/>
                <Link to='/dashboard'>
                <div className="btn reset-btn mx-2 px-5" >Home </div>
                </Link>
                <Link to="/ai/addchannel">
                <div className="btn add-new-btn mx-2 px-5">Delete Another One</div>
                </Link>
            </div>
            </Modal>
            </div>
        );
    }
}


DeleteChannel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DeleteChannel);
